import type { CSSProperties } from "react";
import { Sigil } from "../Sigil";
import { factionFor } from "../../theme/factions";
import { pixelTheme } from "../../theme/pixel";
import { E32 } from "../../theme/endesga32";

interface FactionTileProps {
  faction: "humans" | "goblins" | "dwarves" | "orcs" | "elves";
  tagline: string;
}

// One card in the 5-up factions strip. Sigil on top, faction name, then
// the design's one-line "tagline". Uses the bitmap drop-shadow ladder
// from the design system.
export function FactionTile({ faction, tagline }: FactionTileProps) {
  const f = factionFor(faction);

  const tile: CSSProperties = {
    background: pixelTheme.panelSolid,
    border: `2px solid ${E32.ink}`,
    boxShadow: `4px 4px 0 0 ${E32.ink}`,
    padding: "24px 14px 20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 14,
    textAlign: "center",
    imageRendering: "pixelated",
  };

  return (
    <div style={tile}>
      <div
        style={{
          width: 64,
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Sigil faction={f.key} size={64} />
      </div>
      <div
        style={{
          fontFamily: pixelTheme.fontDisplay,
          fontSize: 11,
          letterSpacing: pixelTheme.letterSpacing,
          textTransform: "uppercase",
          color: pixelTheme.ink,
        }}
      >
        {f.name}s
      </div>
      <div
        style={{
          fontFamily: pixelTheme.fontBody,
          fontSize: 15,
          color: pixelTheme.inkDim,
          lineHeight: 1.35,
        }}
      >
        {tagline}
      </div>
    </div>
  );
}
